export const helpUrl = '/content/faqs'
